import { IVehiclePricingMatrix } from "../models/account/IAccountPartPricingMatrix";

// Recycling accounts are sourcing/flow destinations, not biddable, so they're
// excluded from the matrix's biddable columns (mirrors VehiclePricingMatrix).
const RECYCLING_ACCOUNT_TYPE = 8;

// Sum of the best (highest) enabled, priced cell per category — i.e. the
// "Total Best" figure shown at the bottom of the VehiclePricingMatrix.
// Note: this uses the persisted account-pricing cells only and does not include
// the transient client-side RS Automotive lookup that the matrix folds in.
export default function bestColumnTotal(matrix?: IVehiclePricingMatrix | null): number {
  if (!matrix) return 0;

  const biddableAccountIds = new Set(
    matrix.accounts
      .filter((account) => account.accountType !== RECYCLING_ACCOUNT_TYPE)
      .map((account) => account.accountId)
  );

  return matrix.categories.reduce((sum, category) => {
    const prices = category.cells
      .filter(
        (cell) => biddableAccountIds.has(cell.accountId) && cell.enabled && cell.price != null
      )
      .map((cell) => cell.price as number);

    return sum + (prices.length ? Math.max(...prices) : 0);
  }, 0);
}
